<form class="dialog" [formGroup]="cloneForm" (ngSubmit)="onContinue()">
  <div class="dialog-container">
    <div class="top-elements">
      <div class="dialog-close-btn-container">
        <button
          class="dialog-close-btn"
          [mat-dialog-close]="false"
          type="button"
        ></button>
      </div>
    </div>
    <h2 class="dialog-title">{{ title }}</h2>
    <p class="dialog-text">{{ text }}</p>
    <ling-input type="number" formControlName="amount"></ling-input>
    <mat-dialog-actions class="dialog-actions" align="center">
      <button
        class="dialog-action-button"
        mat-flat-button
        type="submit"
        color="primary"
      >
        {{ confirmButtonText }}
      </button>
    </mat-dialog-actions>
  </div>
</form>
